import React from "react";

interface OfferingRibbonProps {
  ribbonMessage: string;
  style?: React.CSSProperties;
}

export function OfferingRibbon(props: OfferingRibbonProps) {
  const { ribbonMessage, style } = props;

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: 5,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        width: 165,
        top: 37,
        left: 37,
        transform: "translate(-50%, -50%) rotate(-45deg)",
        ...style,
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: 80,
        }}
      >
        <span className="fw-bold">{ribbonMessage}</span>
      </div>
    </div>
  );
}
